import React, {useEffect} from "react";
import {
    Card,
    CardContent,
    CardMedia,
    Typography,
    Avatar,
    Button, IconButton, Divider,
    TextField, List, ListItem, ListItemAvatar, ListItemText,
    Dialog, DialogTitle, DialogContent, Menu, MenuItem, Chip
} from "@material-ui/core";

import {arrayFilter, buildShapperPath, choiceImage, isResponsive, parserContent} from "../../../helpers/Tools";
import BreadCrumbs from "../../../components/BreadCrumbs";
import FlatList from 'flatlist-react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {compose} from 'redux';
import {withTranslation} from 'react-i18next';
import OpenItem from "../../../helpers/OpenItem";
import { useState } from "react";

import {baseApiUrl, uploadMediaStatic} from "../../../api/api";
import {store} from "../../../store/store";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faSyncAlt,
    faComment, faEllipsisV, faFile,
    faGrinHearts,
    faPaperPlane, faRulerVertical,
    faThumbsUp, faWindowClose, faPaperclip,faChevronDown
} from "@fortawesome/free-solid-svg-icons";

import { faThumbsUp as faThumbsDownRegular, faWindowClose as faWindowCloseRegular, faComment as faCommentRegular } from '@fortawesome/free-regular-svg-icons';


import {FormulaireDynamicPicture} from "../../Formulaire/FormulaireDynamic/Formulaire.Dynamic.Picture";
import ImageUploader from "./ImageUploader";
import VideoUploader from "./VideoUploader";
import AttachmentUploader from "./AttachmentUploader";
import ResponsiveMedia from "./ResponsiveMedia";
import MediaThumb from "./MediaThumb";
import DialogMediaViewer from "./DialogMediaViewer";

const PostItem = ({tile, key, dataPage, fetchSocialPosts, handleNewPost, handleLike, handleOpen, handleClose, handleShowLikes, onUpdateState}) => {
    console.log("renderCategory");

    console.log(dataPage);

    const [expanded, setExpanded] = useState(false);
    const [open, setOpen] = useState(false);
    const [openLikes, setOpenLikes] = useState(false);
    const [openFullImage, setOpenFullImage] = useState(false);

    const [comments, setComments] = useState([]);
    const [reactions, setReactions] = useState([]);
    const [commentText, setCommentText] = useState('');
    const [commentId, setCommentId] = useState(null);
    const [like, setLike] = useState('');

    let state = store.getState();
    const isConnected = state.contentauth?.success || state.contentauthSso?.success;

    handleClose = () => setOpen(false);
    const handleCloseLikes = () => setOpenLikes(false);

    let text = tile.content;


    let textFormated = text.replace(/(\r\n|\n|\r)/gm, "<br/>");
    //catch urls
    let regExUrl = /((https?:\/\/)|(www\.))([a-zA-Z0-9\-._~:/?#[\]@!$&'()*+,;=]+)/gim;
    textFormated = textFormated.replace(regExUrl, function (url) {
        let newUrl = url;
        if (!url.startsWith("http")) {
            newUrl = "http://" + url;
        }
        return `<a href="${newUrl}" target="_blank">${url}</a>`;
    });

    //const prenomnom = tile.prenom + " " + tile.nom;
    const prenomnom = tile.author.firstname + " " + tile.author.lastname;
    //const timeAgo = tile.timeAgo;
    //"publish_date": "2025-03-24 12:09:00",
    const publish_date = tile.created_at;
    const date = new Date(publish_date);
    const timeAgo = date.toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
    });

    handleOpen = async () => {
        setOpen(true);
        try {
            const response = await fetch(baseApiUrl + '/getInteractionsByContentId', {
                method: 'POST', // Requête POST, comme dans le curl
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    'appId': state.application.getApp.id,
                    'mobinauteId': parseInt(state.profil.mobinaute.id, 10),
                    'contentId': tile.id, // ID du contenu
                    'offset': '0',
                    'limit': '100'
                })
            });

            const data = await response.json();

            if (!data.success) {
                throw new Error('Erreur lors de la récupération des commentaires');
            }


            const comments = data.result.comments;

            console.log("comments");
            console.log(comments);

            setComments(comments); // Assurez-vous que `data` contient les commentaires sous la forme attendue

        } catch (error) {
            console.error('Erreur lors du chargement des commentaires:', error);
        }
    };

    handleLike = async () => {
        setLike(true);
        try {
            const response = await fetch(baseApiUrl + '/setInteractionForContentId', {
                method: 'POST', // Méthode POST
                body: new URLSearchParams({
                    'appId': state.application.getApp.id,
                    'mobinauteId': parseInt(state.profil.mobinaute.id, 10),
                    'contentId': tile.id, // ID du contenu
                    'type': 'reaction', // Type d'interaction
                    'value': tile.is_liked ? null : '👍🏼' // Valeur de l'interaction
                })
            });

            const data = await response.json();

            //refresh posts
            let posts = fetchSocialPosts();

            if (!data.success) {
                throw new Error('Erreur lors du like');
            }
        } catch (error) {
            console.error('Erreur lors du chargement des commentaires:', error);
        }
    };

    handleShowLikes = async () => {

        //on affiche comme pour les ocmmentaires
        setOpenLikes(true);
        try {
            const response = await fetch(baseApiUrl + '/getInteractionsByContentId', {
                method: 'POST', // Requête POST, comme dans le curl
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    'appId': state.application.getApp.id,
                    'mobinauteId': parseInt(state.profil.mobinaute.id, 10),
                    'contentId': tile.id, // ID du contenu
                    'offset': '0',
                    'limit': '100'
                })
            });

            const data = await response.json();

            if (!data.success) {
                throw new Error('Erreur lors de la récupération des commentaires');
            }


            const reactions = data.result.reactions_mobinautes;
            console.log("reactions");
            console.log(reactions);
            setReactions(reactions); // Assurez-vous que `data` contient les commentaires sous la forme attendue

        } catch (error) {
            console.error('Erreur lors du chargement des commentaires:', error);
        }

    };

    const handleSubmitComment = async (commentText) => {
        try {


            let bodyComment = {
                'appId': state.application.getApp.id,
                'mobinauteId': parseInt(state.profil.mobinaute.id, 10),
                'contentId': tile.id, // ID du contenu
                'type': 'comment', // Type d'interaction
                'value': commentText // Le texte du commentaire
            };

            //if edit
            if (commentId) {
                bodyComment.interactionId = commentId;
                bodyComment.type = 'updateComment';
            }


            const response = await fetch(baseApiUrl + '/setInteractionForContentId', {
                method: 'POST', // Méthode POST
                body: new URLSearchParams(bodyComment)
            });

            if (!response.ok) {
                throw new Error('Erreur lors de l\'envoi du commentaire');
            }



            const data = await response.json();
            console.log('Commentaire envoyé avec succès:', data);
            // Réinitialiser le champ de texte du commentaire
            setCommentText('');
            setCommentId(null);
            // Optionnellement, tu peux recharger les commentaires après avoir ajouté un nouveau commentaire
            handleOpen(); // Récupère les nouveaux commentaires après l'envoi
            //refresh posts
            let posts = fetchSocialPosts();
        } catch (error) {
            console.error('Erreur lors de l\'envoi du commentaire:', error);
        }
    };

    console.log("tile");
    console.log(tile);

    const handleImageClick = () => {
        setOpenFullImage(true);
    };

    const handleImageClose = () => {
        setOpenFullImage(false);
    };

    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);

    const handleOptionPostClose = () => {
        setAnchorEl(null);
    };
    const handleOptionPostEdit = (tile) => {
        handleOptionPostClose();
        //open edit post form
        console.log("handleOptionPostEdit");
        console.log(tile);
        console.log(tile.social_feed_ids.join(','));


        onUpdateState({
            openNewPost: true,
        });
        const isVideoUrl = (url = "") => /\.(mp4|webm|ogg|mov|m4v)(\?|#|$)/i.test(url);

        if (tile) {
            const media = tile.media_urls || [];

            const imageUrls = media
                .map(m => m.url)
                .filter(url => url && !isVideoUrl(url));

            const videoUrls = media
                .map(m => m.url)
                .filter(url => url && isVideoUrl(url));

            onUpdateState({
                openNewPost: true,
                post_id: tile.id,
                post_title: tile.title,
                post_message: tile.content,
                post_keywords: tile.keywords,
                post_social_feed_ids: tile.social_feed_ids.join(",") + ",",
                post_image: imageUrls.join(","),       // ✅ images uniquement
                post_video: videoUrls.join(","),       // ✅ vidéos uniquement
                post_file: tile.file_urls?.length > 0 ? tile.file_urls.map(f => f.url).join(",") : "",
            });
        }


/*
        setStateComponent({
            openNewPost: true
        });
        if(tile) {
            setStateComponent({
                openNewPost: true,
                post_id: tile.id,
                post_title: tile.title,
                post_message: tile.content,
                post_keywords: tile.keywords,
                post_image: tile.media_url,
                post_file: tile.file_url,
            });
        }*/

        //je veux faire un set state dans le composant parent








    };
    const handleOptionPostDelete = async (tile) => {
        handleOptionPostClose();
        //open delete post form
        console.log("handleOptionPostDelete");

        //confirmation
        if (!window.confirm("Êtes-vous sûr de vouloir supprimer ce post ?")) {
            return;
        }

        //send delete post request
        let token = '';
        if (typeof state.profil.mobinaute.accounts !== 'undefined' && typeof state.profil.mobinaute.accounts.shapper_token !== 'undefined') {
            token = state.profil.mobinaute.accounts.shapper_token.access_token;
        } else if (typeof state.application.deviceToken !== 'undefined') {
            token = state.application.deviceToken.access_token;
        }

        const body = new URLSearchParams({
            'contentId': dataPage.id,
            'socialPostId': tile.id, // ID du contenu
        });

        const response = await fetch(baseApiUrl + '/deleteSocialPost', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `Bearer ${token}`,
            },
            body: body

        });
        const data = await response.json();
        console.log("deleteSocialPost");
        console.log(data);
        console.log(data.success);
        if (!data.success) {
            throw new Error('Erreur lors de l\'envoi du post');
        }
        else {
            console.log("Post supprimé avec succès");

            let posts = fetchSocialPosts();

        }


    };

    const handleOptionPostPin = async (tile, pin) => {
        handleOptionPostClose();
        //open delete post form
        console.log("handleOptionPostPin");

        //confirmation
        if (!window.confirm("Êtes-vous sûr de vouloir " + (pin ? "épingler" : "détacher") + " ce post ?")) {
            return;
        }

        //send delete post request
        let token = '';
        if (typeof state.profil.mobinaute.accounts !== 'undefined' && typeof state.profil.mobinaute.accounts.shapper_token !== 'undefined') {
            token = state.profil.mobinaute.accounts.shapper_token.access_token;
        } else if (typeof state.application.deviceToken !== 'undefined') {
            token = state.application.deviceToken.access_token;
        }

        const body = new URLSearchParams({
            'contentId': dataPage.id,
            'socialFeedId': tile.social_feed_ids[0], // on prend le premier
            'socialPostId': tile.id, // ID du contenu
            'pin': pin
        });

        const response = await fetch(baseApiUrl + '/pinPost', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `Bearer ${token}`,
            },
            body: body

        });
        const data = await response.json();
        console.log("pinSocialPost");
        console.log(data);
        console.log(data.success);
        if (!data.success) {
            throw new Error('Erreur lors de l\'epinglage du post');
        }
        else {
            console.log("Post épinglé avec succès");

            let posts = fetchSocialPosts();

        }


    };
    const handleOptionPostReport = async () => {
        handleOptionPostClose();

        //confirmation
        if (!window.confirm("Êtes-vous sûr de vouloir signaler ce post ?")) {
            return;
        }

        //open report post form
        console.log("handleOptionPostReport");

        //send delete post request
        let token = '';
        if (typeof state.profil.mobinaute.accounts !== 'undefined' && typeof state.profil.mobinaute.accounts.shapper_token !== 'undefined') {
            token = state.profil.mobinaute.accounts.shapper_token.access_token;
        } else if (typeof state.application.deviceToken !== 'undefined') {
            token = state.application.deviceToken.access_token;
        }

        const body = new URLSearchParams({
            'contentId': dataPage.id,
            'socialPostId': tile.id, // ID du contenu
        });

        const response = await fetch(baseApiUrl + '/reportSocialPost', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `Bearer ${token}`,
            },
            body: body

        });
        const data = await response.json();
        console.log("deleteSocialPost");
        console.log(data);
        console.log(data.success);
        if (!data.success) {
            throw new Error('Erreur lors de l\'envoi du post');
        } else {
            console.log("Post supprimé avec succès");

            let posts = fetchSocialPosts();
        }

    };



    const [anchorCommentEl, setAnchorCommentEl] = useState(null);
    const [activeCommentIndex, setActiveCommentIndex] = useState(null)

    const handleMenuCommentOpen = (event, index) => {
        setAnchorCommentEl(event.currentTarget);
        setActiveCommentIndex(index);
    };

    const handleMenuCommentClose = () => {
        setAnchorCommentEl(null);
        setActiveCommentIndex(null);
    };

    ;

    const openMenuComment = Boolean(anchorCommentEl);
    const handleCommentPostClose = () => {
        setAnchorCommentEl(null);
    };

    const handleCommentPostEdit = async (comment) => {
        handleCommentPostClose();
        //open edit post form
        console.log("handleOptionPostEdit");

        setCommentText(comment.commentaire)
        setCommentId(comment.id);

    };
    const handleCommentPostDelete = async (tile, comment) => {
        handleCommentPostClose();
        //open delete post form
        console.log("handleOptionPostDelete");


        try {
            const response = await fetch(baseApiUrl + '/setInteractionForContentId', {
                method: 'POST', // Méthode POST
                body: new URLSearchParams({
                    'appId': state.application.getApp.id,
                    'mobinauteId': parseInt(state.profil.mobinaute.id, 10),
                    'contentId': tile.id,
                    'type': 'deleteComment', // Type d'interaction
                    'value': null, // Valeur de l'interaction
                    'interactionId': comment.id // Valeur de l'interaction
                })
            });

            const data = await response.json();

            const responseComment = await fetch(baseApiUrl + '/getInteractionsByContentId', {
                method: 'POST', // Requête POST, comme dans le curl
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    'appId': state.application.getApp.id,
                    'mobinauteId': parseInt(state.profil.mobinaute.id, 10),
                    'contentId': tile.id, // ID du contenu
                    'offset': '0',
                    'limit': '100'
                })
            });

            const dataComment = await responseComment.json();

            if (!dataComment.success) {
                throw new Error('Erreur lors de la récupération des commentaires');
            }


            const comments = dataComment.result.comments;

            console.log(comments);

            setComments(comments); // Assurez-vous que `data` contient les commentaires sous la forme attendue
        } catch (error) {
            console.error('Erreur lors du chargement des commentaires:', error);
        }
    };
    const handleCommentPostReport = async (comment) => {
        handleCommentPostClose();
        //open report post form

        if (!window.confirm("Êtes-vous sûr de vouloir signaler ce commentaire ?")) {
            return;
        }

        console.log("handleOptionPostReport");


        try {
            const response = await fetch(baseApiUrl + '/setInteractionForContentId', {
                method: 'POST', // Méthode POST
                body: new URLSearchParams({
                    'appId': state.application.getApp.id,
                    'mobinauteId': parseInt(state.profil.mobinaute.id, 10),
                    'contentId': dataPage.id, // ID du contenu
                    'type': 'badComment', // Type d'interaction
                    'value': null, // Valeur de l'interaction
                    'interactionId': comment.id // Valeur de l'interaction
                })
            });

            const data = await response.json();

            //refresh posts
            let posts = fetchSocialPosts();

            if (!data.success) {
                throw new Error('Erreur lors du like');
            }
        } catch (error) {
            console.error('Erreur lors du chargement des commentaires:', error);
        }
    };




    return (
        <Card key={key} style={{ margin: "auto", borderRadius: 3, boxShadow: 3, marginTop: "30px", width: "100%", maxWidth: 800,  position: "relative" }}>
            {/* Bouton more option */}

            {/* Icône More options en haut à droite */}
            <IconButton
                aria-label="more options"
                style={{ position: "absolute", top: 10, right: 10, border : "none", outline: "none" }}
                onClick={(event) => {
                    setAnchorEl(event.currentTarget);
                }}
            >
                <FontAwesomeIcon icon={faEllipsisV} size={"sm"}/>
            </IconButton>
            <Menu anchorEl={anchorEl} open={openMenu} onClose={handleOptionPostClose}>
                {tile.can_pin && !tile.is_pinned &&
                    <MenuItem onClick={() => handleOptionPostPin(tile, 1)}>Epingler</MenuItem>
                }
                {tile.can_pin && tile.is_pinned &&
                    <MenuItem onClick={() => handleOptionPostPin(tile, 0)}>Détacher</MenuItem>
                }

                {tile.can_edit &&
                    <MenuItem onClick={() => handleOptionPostEdit(tile)}>Modifier</MenuItem>
                }
                {tile.can_delete &&
                    <MenuItem onClick={() => handleOptionPostDelete(tile)}>Supprimer</MenuItem>
                }
                {tile.author.id !== state.profil.mobinaute.id &&
                    <MenuItem onClick={handleOptionPostReport}>Signaler</MenuItem>
                }
            </Menu>

            {/* Header */}
            <CardContent sx={{ display: "flex", alignItems: "center" }}>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginLeft: "auto" }}>
                    <Avatar src={buildShapperPath(tile.author.profilMedia)} alt="Profile" sx={{ width: 56, height: 56, mr: 2 }} />
                    <div style={{ paddingLeft: 15 }}>
                        {tile.is_pinned && <Chip label="Post épinglé" color="primary" size="small" style={{ marginRight: 5 }} />}
                        <Typography variant="h6" sx={{ mr: 1 }}>{prenomnom}</Typography>
                        <Typography variant="body2" color="textSecondary">{timeAgo}</Typography>
                        {/*{tile.keywords}*/}
                        <div style={{ display: "flex", flexWrap: "wrap", marginTop: 5 }}>
                            {tile.social_feed_ids && tile.social_feed_ids.map((id, index) => {
                                const socialFeed = dataPage.social_feeds.find(feed => feed.id === id.trim());

                                const backgroundColorFeed = socialFeed ? socialFeed.color : "#3f51b5"; // Couleur par défaut si non trouvé
                                const colorFeed = "#ffffff"; // Couleur du texte par défaut si non trouvé

                                return socialFeed ? (
                                    <Typography key={index} variant="body2" color="textSecondary" style={{ marginRight: 5, padding: 5, color:colorFeed, borderRadius: 5, backgroundColor: backgroundColorFeed }}>
                                        {socialFeed.title}
                                    </Typography>
                                ) : null;
                            })}
                        </div>{/*{tile.keywords}*/}
                        <div style={{ display: "flex", flexWrap: "wrap", marginTop: 5 }}>
                            {tile.keywords && tile.keywords.split(',').filter(keyword => keyword.trim() !== '').map((keyword, index) => {

                                const socialFeed = dataPage.social_feeds.find(feed => feed.keywords && feed.keywords.includes(keyword.trim()));

                                console.log("socialFeed" + socialFeed)

                                const backgroundColorFeed = socialFeed ? socialFeed.color + "77" : "#3f51b5"; // Couleur par défaut si non trouvé
                                const colorFeed = socialFeed ? socialFeed.color + "ff" : "#ffffff"; // Couleur par défaut si non trouvé

                                return  (
                                    <Typography key={index} variant="body2" color="textSecondary" style={{
                                        marginRight: 5,
                                        padding: 5,
                                        borderRadius: 5,
                                        backgroundColor: backgroundColorFeed,
                                        color: colorFeed }}>
                                        {keyword}
                                    </Typography>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </CardContent>


            {/* Contenu */}

            <CardContent>
                {/* Titre et sous-titre */}
                <Typography variant="h5" gutterBottom>{tile.title}</Typography>

                {/* Texte de publication */}
                <Typography variant="body1" paragraph>
                    {!expanded && text.length > 500
                        ? (() => {
                            const maxChars = 500;
                            const maxLineBreaks = 3;

                            // On extrait les 500 premiers caractères
                            const partialText = text.substring(0, maxChars);
                            const lineBreakIndexes = [...partialText.matchAll(/\n/g)].map(match => match.index);

                            let sliceIndex;

                            if (lineBreakIndexes.length > maxLineBreaks) {
                                // Si plus de 2 retours ligne, on coupe après le 2e
                                sliceIndex = lineBreakIndexes[maxLineBreaks - 1];
                            } else {
                                // Sinon, on coupe à la première ligne si elle est avant 500
                                const firstLineBreak = lineBreakIndexes[0];
                                sliceIndex = firstLineBreak !== undefined && firstLineBreak < maxChars
                                    ? firstLineBreak
                                    : maxChars;
                            }

                            return text.substring(0, sliceIndex) + '...';
                        })()
                        : parserContent(textFormated)}
                </Typography>
                {!expanded && text.length > 500 && (
                    <Button onClick={() => setExpanded(true)} color="primary">Voir plus</Button>
                )}
            </CardContent>


            {/* Image d'illustration */}

            {/* une en grand, s'il y en a plus, affichage de 2 images en dessous en petit, si il y en a + , 2 images en dessous + une image avec +x */}
            { tile.media_urls && tile.media_urls.length > 0 && (
                <ResponsiveMedia
                    src={buildShapperPath(tile.media_urls[0].url)}
                    onClick={handleImageClick}
                    controls // mets false si tu veux pas de controls
                />
            )}

            {/* Affichage des autres images */}

            {tile.media_urls && tile.media_urls.length > 1 && (
                <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", paddingTop: 10, paddingBottom: 10 }}>
                    {tile.media_urls.slice(1, 3).map((media, index) => (
                        <MediaThumb
                            key={index}
                            src={buildShapperPath(media.url)}
                            onClick={handleImageClick}
                        />
                    ))}
                    {tile.media_urls.length > 3 && (
                        <div
                            onClick={handleImageClick}
                            style={{
                            width: "32%",
                            height: "auto",
                            margin: "5px",
                            borderRadius: 3,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                            position: "relative",
                            overflow: "hidden", // pour éviter que l'image dépasse
                        }}>
                            {/* Overlay noir semi-transparent */}
                            <div style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "rgba(0, 0, 0, 0.4)", // ici l'opacité du noir
                                zIndex: 2
                            }} />
                            {/* Image floutée en fond */}
                            <div style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundImage: `url(${buildShapperPath(tile.media_urls[3].url)})`,
                                backgroundSize: "cover",
                                filter: "blur(2px)",
                                zIndex: 1,
                            }}></div>

                            {/* Texte par-dessus */}
                            <Typography
                                variant="h6"
                                style={{
                                    color: "#fff",
                                    textShadow: "1px 1px 2px rgba(0,0,0,0.7)",
                                    textAlign: "center",
                                    zIndex: 2,
                                    position: "relative", // important pour passer au-dessus de l'image
                                    padding: "20px", // optionnel, selon ton layout
                                }}
                            >
                                +{tile.media_urls.length - 3} autres
                            </Typography>
                        </div>

                    )}
                </div>
            )}

            {/* Pièce jointe */}



            {tile.file_urls &&
                tile.file_urls.length > 0 && // Si pas d'images mais des fichiers
                tile.file_urls.map((file, index) => (
                    <IconButton
                        key={index}
                        style={{ padding: 10, paddingLeft: 30, maxHeight: 400, cursor: "pointer", outline: "none", border: "none" }}
                        onClick={() => window.open(file.url, '_blank')}
                    >
                        <FontAwesomeIcon icon={faFile} />
                        <Typography variant="body2" color="textSecondary" style={{ marginLeft: 10 }}>
                            {/*file.name || `Pièce jointe ${index + 1}`*/}
                            {`Pièce jointe ${index + 1}`}
                        </Typography>
                    </IconButton>
                ))
            }


            <div  style={{ display: "flex", alignItems: "center", padding: "10px 16px" }}>
            {/* Afficher le nombre de likes si > 0 */}
            { tile.nb_likes > 0 &&
                <Typography className="ml-2 mr-2" onClick={isConnected ? handleShowLikes : undefined} style={{ cursor: isConnected ? "pointer" : "default", color: "#969696", textDecoration: isConnected ? "underline" : "none" }}>
                    {tile.nb_likes} personne{tile.nb_likes >1 ? "s ont" : " a"} réagi à ce post
                </Typography>
            }

            { tile.can_like && tile.can_comment && tile.nb_likes > 0 && tile.nb_comments > 0 &&
                <span style={{ margin: "0 10px" }}>|</span>
            }

            {/* Afficher le nombre de commentaires si > 0 */}
            { tile.can_comment && tile.nb_comments > 0 &&
                <Typography className="ml-2 mr-2" onClick={handleOpen} style={{ cursor: "pointer", color: "#969696", textDecoration: "underline" }}>
                    {tile.nb_comments} commentaire{tile.nb_comments > 1 ? "s" : ""}
                </Typography>
            }

            </div>

            <Divider />

            {/* Boutons */}
            <CardContent style={{ display: "flex", justifyContent: "space-around", padding: "4px" }}>
                {tile.can_like &&
                    <IconButton color="primary" style={{ outline: "none", border: "none" }}>
                        <FontAwesomeIcon onClick={handleLike} icon={tile.is_liked ? faThumbsUp : faThumbsDownRegular } />
                        <Typography className="ml-2" onClick={handleLike}>
                            J'aime
                        </Typography>

                    </IconButton>
                }
                {tile.can_comment &&
                    <IconButton color="primary" onClick={handleOpen} style={{ outline: "none", border: "none" }}>
                        <FontAwesomeIcon
                            icon={faCommentRegular}
                        />

                        <Typography className="ml-2">
                            Commentaires
                        </Typography>
                    </IconButton>
                }
            </CardContent>
            {/* Section des commentaires */}
            {/* Popup de commentaires */}
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
                <IconButton
                    onClick={handleClose}
                    style={{ position: "absolute", top: 10, right: 10}}
                >
                    <FontAwesomeIcon icon={faWindowClose}/>
                </IconButton>
                <DialogTitle>Commentaires</DialogTitle>
                <DialogContent>
                    <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
                        <Avatar src={buildShapperPath(store.getState().profil.mobinaute.profilMedia)} alt="Profile" style={{ width: 40, height: 40, marginRight: 10 }} />
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Écrire un commentaire..."
                            value={commentText}
                            onChange={(e) => {
                                if (e.target.value.length <= 600) {
                                    setCommentText(e.target.value)
                                }
                            }
                            }
                            sx={{ marginLeft: 2 }}
                        />
                        <IconButton
                            color="primary"
                            onClick={() => handleSubmitComment(commentText)}
                            disabled={!commentText.trim()}
                            sx={{ marginLeft: 2 }}
                        >
                            <FontAwesomeIcon icon={faPaperPlane} />
                        </IconButton>
                    </div>
                    <div
                        style={{
                            textAlign: "right",
                            fontSize: "0.8rem",
                            color: commentText.length > 600 ? "red" : "gray",
                            marginBottom: 10,
                        }}
                        >
                        {commentText.length} / 600 caractères
                    </div>

                    {/*SCROLL*/}
                    <div style={{
                        maxHeight: 400,
                        overflowY: "auto",
                        padding: 10,
                    }}>

                        {/* Liste des commentaires */}
                        <List>
                            {comments.map((comment, index) => (
                                <ListItem key={index} alignItems="flex-start">
                                    <ListItemAvatar>
                                        <Avatar src={buildShapperPath(comment.profilMedia)} alt="Profile" />
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={comment.firstname + ' ' + comment.lastname}
                                        secondary={comment.commentaire}
                                    />
                                    <Typography variant="body2" color="textSecondary">
                                        {new Date(comment.createdAt).toLocaleDateString('fr-FR', {
                                            year: 'numeric',
                                            month: '2-digit',
                                            day: '2-digit',
                                            hour: '2-digit',
                                            minute: '2-digit'
                                        })}
                                    </Typography>

                                    {/* Icône More options en haut à droite */}
                                    <IconButton
                                        aria-label="more options"
                                        style={{ border : "none", outline: "none" }}
                                        onClick={(event) => handleMenuCommentOpen(event, index)}
                                    >
                                        <FontAwesomeIcon icon={faEllipsisV} size={"sm"} style={{ fontSize: "0.65rem" }}/>
                                    </IconButton>

                                    <Menu anchorEl={anchorCommentEl} open={activeCommentIndex === index && openMenuComment} onClose={handleMenuCommentClose}>
                                        {comment.can_edit &&
                                            <MenuItem onClick={() => handleCommentPostEdit(comment)}>Modifier</MenuItem>
                                        }
                                        {comment.can_delete &&
                                            <MenuItem onClick={() => handleCommentPostDelete(tile, comment)}>Supprimer</MenuItem>
                                        }
                                        {comment.mobinaute_id !== state.profil.mobinaute.id &&
                                            <MenuItem onClick={() => handleCommentPostReport(comment)}>Signaler</MenuItem>
                                        }
                                    </Menu>

                                </ListItem>
                            ))}
                        </List>

                    </div>

                </DialogContent>
            </Dialog>

            <Dialog open={openLikes} onClose={handleCloseLikes} fullWidth maxWidth="sm">
                <IconButton
                    onClick={handleCloseLikes}
                    style={{ position: "absolute", top: 10, right: 10}}
                >
                    <FontAwesomeIcon icon={faWindowClose}/>
                </IconButton>
                <DialogTitle>Réactions</DialogTitle>
                <DialogContent>
                    {/* Liste des commentaires */}
                    <List>
                        {reactions.map((react, index) => (
                            <ListItem key={index} alignItems="flex-start">
                                <ListItemAvatar>
                                    <Avatar src={buildShapperPath(react.profilMedia)} alt="Profile" />
                                </ListItemAvatar>
                                <ListItemText
                                    primary={react.firstname + ' ' + react.lastname}
                                />

                                <Typography style={{fontSize: "2.5rem", marginLeft: 10, marginTop: 5}} variant="body2" color="textSecondary">
                                    {react.reaction}
                                </Typography>


                            </ListItem>
                        ))}
                    </List>
                </DialogContent>
            </Dialog>

            <DialogMediaViewer
                openFullImage={openFullImage}
                handleImageClose={handleImageClose}
                tile={tile}
                buildShapperPath={buildShapperPath}
            />
        </Card>
    );
}

class SocialFeed extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            posts: [],
            open: false,
            comments: [],
            reactions: [],
            commentText: '',
            like: '',
            selectedImages: [],
            selectedImageUrls: [],
            selectedVideos: [],
            selectedVideosUrls: [],
            selectedAttachments: [],
            selectedAttachmentUrls: [],
            post_id: '',
            post_title: '',
            post_message: '',
            post_keywords: '',
            post_social_feed_ids: '',
            post_image: '',
            post_video: '',
            post_file: '',
            commentId: null,
            lastPostId: null,
        };
    }

    async componentDidMount() {
        let posts = await this.fetchSocialPosts();
    }

    handleUpdateFromChild = (newData) => {
        this.setState({ ...newData });
    };




    render() {
        const dyn_string = this.props.t

        //* Récupération de la liste des posts sociaux */
        //get posts state loaded in componentDidMount
        const { dataPage } = this.props;
        const posts = this.state.posts;


        //je regarde mes rights dans dataPage.social_feeds -> social_feed rights
        const socialFeedsRights = dataPage && dataPage.social_feeds ? dataPage.social_feeds.map(feed => feed.can_publish) : [];
        const hasCreatePostRight = socialFeedsRights.includes(true);

        console.log("hasCreatePostRight");
        console.log(socialFeedsRights);
        console.log("hasCreatePostRight" + hasCreatePostRight);



        const handleNewPost = async () => {
            console.log("handleNewPost");

            //open newPostForm dialog
            this.setState({
                openNewPost: true,
                post_id: '',
                post_title: '',
                post_message: '',
                post_keywords: '',
                post_social_feed_ids: '',
                post_image: '',
                post_video: '',
                post_file: '',
            });

        };

        const handleNewPostClose = () => {
            this.setState({openNewPost: false });
        }


        const avatarUrl = buildShapperPath(store.getState().profil.mobinaute.profilMedia);

        //bouton nouveau post
        const newPostButton = (
        <div style={{ display: "flex", alignItems: "center", marginBottom: 10, width: "100%",maxWidth: "800px", marginLeft: "auto", marginRight: "auto", marginTop: "20px", backgroundColor: "#f5f5f5", color: "#fff"
            , center: "center", justifyContent: "center", borderRadius: "5px", padding: "20px 20px" }} onClick={handleNewPost}>
            <Avatar alt="Profile" style={{ width: 40, height: 40, marginRight: 10 }} src={avatarUrl} />
            <TextField
                fullWidth
                variant="outlined"
                placeholder={dyn_string('g_label_message')}
                sx={{ marginLeft: 2 }}
            />
            <IconButton
                color="primary"
                disabled={true}
                sx={{ marginLeft: 2 }}
            >
                <FontAwesomeIcon icon={faPaperPlane} />
            </IconButton>
        </div>

        );

        const handleImageSelected = async (files) => {
            let { selectedImages, selectedImageUrls } = this.state;

            for (const file of files) {
                // Ajouter l'image locale
                selectedImages = [...selectedImages, file];
                this.setState({ selectedImages });
                console.log('Fichier image sélectionné:', file);

                // Si c'est un fichier à uploader
                if (file && file.type) {
                    const responseUploadMediaStatic = await uploadMediaStatic(file);
                    console.log('responseUploadMediaStatic:', responseUploadMediaStatic);
                    if (responseUploadMediaStatic.success) {
                        selectedImageUrls = [...selectedImageUrls, responseUploadMediaStatic.result.file_url];
                        this.setState({ selectedImageUrls });
                    } else {
                        console.error('Erreur lors de l\'upload de l\'image:', responseUploadMediaStatic.error);
                    }
                }
                // Si c'est une URL directement
                else {
                    selectedImageUrls = [...selectedImageUrls, file];
                    this.setState({ selectedImageUrls });
                }
            }
        };
        const handleImageRemoved = (index) => {
            let { selectedImages, selectedImageUrls } = this.state;

            console.log("Suppression de l'image à l'index :", index);

            // Supprimer l'image à l'index spécifié
            selectedImages = selectedImages.filter((_, i) => i !== index);
            selectedImageUrls = selectedImageUrls.filter((_, i) => i !== index);

            this.setState({ selectedImages, selectedImageUrls });
        };

        const asArray = (x) => (Array.isArray(x) ? x : (x ? [x] : []));

        const handleVideoSelected = async (filesOrFile) => {
            const files = asArray(filesOrFile);

            let { selectedVideos = [], selectedVideoUrls = [] } = this.state;

            // si jamais ça arrive en string (ex: "a,b,c"), on convertit
            if (typeof selectedVideoUrls === "string") {
                selectedVideoUrls = selectedVideoUrls
                    .split(",")
                    .map(s => s.trim())
                    .filter(Boolean);
            }

            for (const item of files) {
                if (item && item.type) {
                    selectedVideos = [...selectedVideos, item];
                    this.setState({ selectedVideos });

                    const res = await uploadMediaStatic(item);
                    if (res?.success) {
                        selectedVideoUrls = [...selectedVideoUrls, res.result.file_url];
                        this.setState({ selectedVideoUrls });
                    } else {
                        console.error("Erreur upload vidéo:", res?.error);
                    }
                } else if (typeof item === "string") {
                    selectedVideoUrls = [...selectedVideoUrls, item];
                    this.setState({ selectedVideoUrls });
                }
            }
        };


        const handleVideoRemoved = (index) => {
            this.setState((prev) => ({
                selectedVideos: (prev.selectedVideos || []).filter((_, i) => i !== index),
                selectedVideoUrls: (prev.selectedVideoUrls || []).filter((_, i) => i !== index),
            }));
        };


        const handleAttachmentSelected = async (files) => {
            let { selectedAttachments, selectedAttachmentUrls } = this.state;
            console.log('Fichier sélectionné:', files);
            // Tu pourrais ici l’envoyer vers un backend
            // go upload

            for (const file of files) {
                // Ajouter l'image locale
                selectedAttachments = [...selectedAttachments, file];
                this.setState({ selectedAttachments });
                console.log('Fichier sélectionné:', file);
                if (file && file.type) {
                    const responseUploadMediaStatic = await uploadMediaStatic(file);
                    console.log('responseUploadMediaStatic:', responseUploadMediaStatic);
                    if (responseUploadMediaStatic.success) {
                        selectedAttachmentUrls = [...selectedAttachmentUrls, responseUploadMediaStatic.result.file_url];
                        this.setState({ selectedAttachmentUrls });
                    } else {
                        console.error('Erreur lors de l\'upload du fichier:', responseUploadMediaStatic.error);
                    }
                }
                else {
                    selectedAttachmentUrls = [...selectedAttachmentUrls, file];
                    this.setState({ selectedAttachmentUrls });
                }
            }
        };

        const handleAttachmentRemoved = (index) => {
            let { selectedAttachments, selectedAttachmentUrls } = this.state;

            console.log("Suppression du fichier à l'index :", index);

            // Supprimer l'image à l'index spécifié
            selectedAttachments = selectedAttachments.filter((_, i) => i !== index);
            selectedAttachmentUrls = selectedAttachmentUrls.filter((_, i) => i !== index);

            this.setState({ selectedAttachments, selectedAttachmentUrls });
        };

        const newPostForm = (
            <Dialog open={this.state.openNewPost} onClose={handleNewPostClose} fullWidth maxWidth="md">
                <IconButton
                    onClick={handleNewPostClose}
                    style={{ position: "absolute", top: 10, right: 10, color: "#3f51b5" }}
                >
                    <FontAwesomeIcon icon={faWindowClose} />
                </IconButton>
                <DialogTitle>{dyn_string('g_label_new_post')}</DialogTitle>
                <DialogContent>
                    <TextField
                        margin="dense"
                        id="title"
                        label={dyn_string('g_label_title')}
                        rows={4}
                        type="text"
                        fullWidth
                        variant="outlined"
                        value={this.state.post_title}
                        onChange={(e) => {
                                if (e.target.value.length <= 150) {
                                    this.setState({ post_title: e.target.value })
                                }
                            }
                        }
                    />
                    <div
                    style={{
                        textAlign: "right",
                        fontSize: "0.8rem",
                        color: this.state.post_title.length > 150 ? "red" : "gray",
                        marginBottom: 10,
                    }}
                >
                        {this.state.post_title.length} / 150 caractères
                    </div>

                    <TextField
                        margin="dense"
                        id="message"
                        label={dyn_string('g_label_content')}
                        multiline={true}
                        rows={4}
                        type="text"
                        fullWidth
                        variant="outlined"
                        value={this.state.post_message}
                        onChange={(e) => {
                                if (e.target.value.length <= 1000) {
                                    this.setState({ post_message: e.target.value })
                                }
                            }
                        }
                    />
                    <div
                    style={{
                        textAlign: "right",
                        fontSize: "0.8rem",
                        color: this.state.post_message.length > 1000 ? "red" : "gray",
                        marginBottom: 10,
                    }}
                >
                    {this.state.post_message.length} / 1000 caractères
                </div>

                    { dataPage && dataPage.social_feeds && dataPage.social_feeds.length > 0 && (
                        <Typography variant="subtitle1" style={{ marginTop: '10px' }}>
                            {dyn_string('g_label_social_feed')}
                        </Typography>
                    )}

                    { dataPage && dataPage.social_feeds && dataPage.social_feeds.map((social_feed, index) => (
                        <Chip
                            key={index}
                            label={social_feed.title.trim()}
                            color={this.state.post_social_feed_ids && this.state.post_social_feed_ids.includes(social_feed.id.trim() + ',') ? social_feed.color : 'default'}
                            onDelete={() => {
                                if(social_feed.can_publish) {
                                    // Handle keyword delete if needed
                                    console.log(`Keyword deleted: ${social_feed.id}`);
                                    //remove
                                    this.setState({post_social_feed_ids: this.state.post_social_feed_ids.replace(social_feed.id.trim() + ',', '')});
                                }
                            }}
                            onClick={() => {
                                if(social_feed.can_publish) {
                                    // Handle keyword click if needed
                                    console.log(`Keyword clicked: ${social_feed.id}`);
                                    if (!this.state.post_social_feed_ids || !this.state.post_social_feed_ids.includes(social_feed.id.trim() + ',')) {
                                        this.setState({post_social_feed_ids: this.state.post_social_feed_ids ? this.state.post_social_feed_ids + social_feed.id.trim() + ',' : social_feed.id.trim() + ','});
                                    }
                                }

                            }}
                            style={{
                                margin: '5px',
                                backgroundColor: this.state.post_social_feed_ids &&
                                this.state.post_social_feed_ids.includes(social_feed.id.trim() + ',')
                                    ? social_feed.color + 'ff'
                                    : '#e0e0e0', // couleur par défaut
                                color: this.state.post_social_feed_ids &&
                                this.state.post_social_feed_ids.includes(social_feed.id.trim() + ',')
                                    ? '#fff'
                                    : '#000', // couleur par défaut
                            }}
                        />
                    ))}

                    { dataPage && dataPage.keyword && dataPage.social_feeds.length > 0 && (
                        <Typography variant="subtitle1" style={{ marginTop: '10px' }}>
                            {dyn_string('g_label_keywords')}
                        </Typography>
                    )}

                    { dataPage && dataPage.social_feeds &&
                        dataPage.social_feeds.map((social_feed, index) => (
                            social_feed.keywords.map((keyword, index) => (
                            <Chip
                                key={index}
                                label={keyword.trim()}
                                color={this.state.post_keywords && this.state.post_keywords.includes(keyword.trim() + ',') ? 'primary' : 'default'}
                                onDelete={() => {
                                    // Handle keyword delete if needed
                                    console.log(`Keyword deleted: ${keyword}`);
                                    //remove
                                    this.setState({ post_keywords: this.state.post_keywords.replace(keyword.trim() + ',', '') });
                                }}
                                onClick={() => {
                                    // Handle keyword click if needed
                                    console.log(`Keyword clicked: ${keyword}`);
                                    if (this.state.post_social_feed_ids.includes(social_feed.id.trim() + ',')) {
                                        if (!this.state.post_keywords || !this.state.post_keywords.includes(keyword.trim() + ',')) {
                                            this.setState({post_keywords: this.state.post_keywords ? this.state.post_keywords + keyword.trim() + ',' : keyword.trim() + ','});
                                        }
                                    }

                                }}
                                style={{ margin: '5px',
                                    display : this.state.post_social_feed_ids.includes(social_feed.id.trim() + ',') ? '' : 'none',
                                    backgroundColor: this.state.post_social_feed_ids &&
                                    this.state.post_social_feed_ids.includes(social_feed.id.trim() + ',')
                                        && this.state.post_keywords &&
                                    this.state.post_keywords.includes(keyword.trim() + ',')
                                        ? social_feed.color + '77'
                                        : '#e0e0e0', // couleur par défaut
                                    color: this.state.post_social_feed_ids &&
                                    this.state.post_social_feed_ids.includes(social_feed.id.trim() + ',')
                                        && this.state.post_keywords &&
                                    this.state.post_keywords.includes(keyword.trim() + ',')
                                        ? social_feed.color + 'ff'
                                        : '#000', // couleur par défaut
                                }}
                            />
                        ))
                        ))
                    }

                    <TextField
                        margin="dense"
                        id="social_feed_ids"
                        label={dyn_string('g_label_keywords')}
                        rows={4}
                        style={{ display: 'none' }}
                        fullWidth
                        variant="outlined"
                        placeholder={dyn_string('g_label_keywords_placeholder')}
                        disabled={true}
                        value={this.state.post_social_feed_ids}
                        onChange={(e) => this.setState({ post_social_feed_ids: e.target.value })}
                    />

                    <TextField
                        margin="dense"
                        id="keywords"
                        label={dyn_string('g_label_keywords')}
                        rows={4}
                        style={{ display: 'none' }}
                        fullWidth
                        variant="outlined"
                        placeholder={dyn_string('g_label_keywords_placeholder')}
                        disabled={true}
                        value={this.state.post_keywords}
                        onChange={(e) => this.setState({ post_keywords: e.target.value })}
                    />

                    <div style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "24px",
                        marginTop: "24px",
                        alignItems: "flex-start"
                    }}>
                        <div style={{
                            flex: "1 1 300px",
                            minWidth: "300px",
                            background: "#fafafa",
                            padding: "16px",
                            borderRadius: "8px",
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)"
                        }}>
                            <Typography variant="subtitle1" style={{ marginBottom: 8 }}>
                                Images
                            </Typography>
                            <ImageUploader
                                onImageSelected={handleImageSelected}
                                onImageRemoved={handleImageRemoved}
                                defaultValue={this.state.post_image}
                                multiple={true}
                                positionPreview="below"
                            />
                        </div>

                        <div style={{
                            flex: "1 1 300px",
                            minWidth: "300px",
                            background: "#fafafa",
                            padding: "16px",
                            borderRadius: "8px",
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)"
                        }}>
                            <Typography variant="subtitle1" style={{ marginBottom: 8 }}>
                                Vidéos
                            </Typography>
                            <VideoUploader
                                onVideoSelected={handleVideoSelected}
                                onVideoRemoved={handleVideoRemoved}
                                defaultValue={this.state.post_video}
                                multiple={true}
                                positionPreview="below"
                            />
                        </div>

                        <div style={{
                            flex: "1 1 300px",
                            minWidth: "300px",
                            background: "#fafafa",
                            padding: "16px",
                            borderRadius: "8px",
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)"
                        }}>
                            <Typography variant="subtitle1" style={{ marginBottom: 8 }}>
                                Pièces jointes
                            </Typography>
                            <AttachmentUploader
                                multiple={true}
                                defaultValue={this.state.post_file}
                                onAttachmentSelected={handleAttachmentSelected}
                                onAttachmentRemoved={handleAttachmentRemoved}
                            />
                        </div>

                        <div style={{
                            flex: "1 1 300px",
                            minWidth: "300px",
                            padding: "16px",
                        }}>
                        </div>
                    </div>


                    <Button
                        variant="contained"
                        color="primary"
                        onClick={async () => {
                            //handleNewPost
                            const id = this.state.post_id;
                            const title = document.getElementById("title").value;
                            const message = document.getElementById("message").value;
                            const keywords = document.getElementById("keywords").value;
                            const social_feed_ids = document.getElementById("social_feed_ids").value;

                            const attachment = this.state.selectedAttachmentUrls || null;
                            const imageUrls = this.state.selectedImageUrls || [];
                            const videoUrls = this.state.selectedVideoUrls || [];
                            const mediaUrls = [...imageUrls, ...videoUrls];


                            //call uploadMediaStatic webservice

                            await this.handleNewPost({
                                socialPostId: id,
                                title: title,
                                message: message,
                                image: mediaUrls,
                                fileUrl: attachment,
                                keywords: keywords,
                                socialFeedIds: social_feed_ids,
                            });

                            //refresh posts
                            let posts = await this.fetchSocialPosts().then(
                                (response) => {
                                    console.log("response");
                                    console.log(response);

                                    this.setState({ posts: response });

                                    return response;
                                }
                            ).catch((error) => {
                                console.error('Erreur lors de la récupération des posts:', error);
                            });



                            this.setState({ openNewPost: false });
                        }}
                        style={{ marginTop: "20px", width: "100%", maxWidth: "800px", marginLeft: "auto", marginRight: "auto", backgroundColor: "#3f51b5", color: "#fff"
                            , center: "center", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "5px", padding: "10px 20px" }}
                    >
                        {dyn_string('g_label_post')}
                    </Button>
                </DialogContent>
            </Dialog>
        );

        const setStateComponent = async (state) => {
            this.setState(state);
        };

        if (isResponsive()) {
            return (
                <div>
                    <BreadCrumbs id={this.props.dataPage.id} style={{marginBottom: "20px"}}/>
                    {hasCreatePostRight && (
                        newPostButton
                    )}
                    <div>
                        {/*BTN REFRESH*/}
                        <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
                            <Button
                                startIcon={<FontAwesomeIcon icon={faSyncAlt} />}
                                variant="contained"
                                color="primary"
                                onClick={async () => {
                                    let posts = await this.fetchSocialPosts().then(
                                        (response) => {
                                            console.log("response");
                                            console.log(response);

                                            this.setState({ posts: response });

                                            return response;
                                        }
                                    ).catch((error) => {
                                        console.error('Erreur lors de la récupération des posts:', error);
                                    });
                                }}
                                style={{ width: "100%", maxWidth: "800px", backgroundColor: "#3f51b5", color: "#fff"
                                    , center: "center", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "5px", padding: "10px 20px" }}
                            >
                                {dyn_string('g_label_refresh')}
                            </Button>

                        </div>
                    </div>
                    {newPostForm}
                <ul style={{
                    padding: 0,
                    listStyle: "none",
                    gridTemplateColumns: "repeat(auto-fill, minmax(400px, 1fr))",
                    paddingInlineStart: "20px",
                    paddingInlineEnd: "20px"
                }}>
                    <FlatList
                        list={posts}
                        renderItem={this.renderCategory}
                        renderWhenEmpty={() => <h4
                            style={{marginTop: "70px", textAlign: "center"}}>{dyn_string('g_label_no_result')}</h4>}
                        display={{
                            grid: false,
                            gridGap: "20px",
                        }}
                        style={{listStyle: "none", backgroundColor: '#ffffff', marginTop: "20px", padding: 0}}
                    />
                    {posts.length > 0 &&
                        <div style={{marginTop: "20px", textAlign: "center"}}>
                            <Button
                                startIcon={<FontAwesomeIcon icon={faChevronDown} />}
                                variant="contained"
                                color="primary"
                                onClick={async () => {
                                    let posts = await this.fetchSocialPosts(this.state.lastPostId).then(
                                        (response) => {
                                            console.log("response");
                                            console.log(response);

                                            return response;
                                        }
                                    ).catch((error) => {
                                        console.error('Erreur lors de la récupération des posts:', error);
                                    });

                                    let allPosts = [...this.state.posts, ...posts];
                                    console.log("allPosts");
                                    console.log(allPosts);
                                    this.setState({ posts: allPosts });
                                }}
                                style={{ width: "100%", maxWidth: "800px", marginLeft: "auto", marginRight: "auto", backgroundColor: "#3f51b5", color: "#fff"
                                    , center: "center", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "5px", padding: "10px 20px" }}
                            >
                                {dyn_string('g_label_load_more')}
                            </Button>
                        </div>
                    }
                </ul>
                </div>
            );
        }
        else {
            return (
                <div>
                    <BreadCrumbs id={this.props.dataPage.id} style={{marginBottom: "20px"}}/>
                    {hasCreatePostRight && (
                        newPostButton
                    )}
                    <div>
                        {/*BTN REFRESH*/}
                        <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
                            <Button
                                startIcon={<FontAwesomeIcon icon={faSyncAlt} />}
                                variant="contained"
                                color="primary"
                                onClick={async () => {
                                    let posts = await this.fetchSocialPosts().then(
                                        (response) => {
                                            console.log("response");
                                            console.log(response);

                                            this.setState({ posts: response });

                                            return response;
                                        }
                                    ).catch((error) => {
                                        console.error('Erreur lors de la récupération des posts:', error);
                                    });
                                }}
                                style={{ width: "100%", maxWidth: "800px", backgroundColor: "#3f51b5", color: "#fff"
                                    , center: "center", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "5px", padding: "10px 20px" }}
                            >
                                {dyn_string('g_label_refresh')}
                            </Button>

                        </div>
                    </div>
                    {newPostForm}
                    <ul style={{
                        gridTemplateColumns: "repeat(auto-fill, minmax(400px, 1fr))",
                        paddingInlineStart: "20px",
                        paddingInlineEnd: "20px"
                    }}>
                        <FlatList
                            list={posts}
                            renderItem={this.renderCategory}
                            renderWhenEmpty={() => <h4
                                style={{marginTop: "70px", textAlign: "center", backgroundColor: '#ffffff'}}>{dyn_string('g_label_no_result')}</h4>}
                            display={{
                                grid: false,
                                gridGap: "40px",
                            }}
                        />
                    </ul>
                    {posts.length > 0 &&
                        <div style={{marginTop: "20px", textAlign: "center"}}>
                            <Button
                                startIcon={<FontAwesomeIcon icon={faChevronDown} />}
                                variant="contained"
                                color="primary"
                                onClick={async () => {
                                    let posts = await this.fetchSocialPosts(this.state.lastPostId).then(
                                        (response) => {
                                            console.log("response");
                                            console.log(response);

                                            return response;
                                        }
                                    ).catch((error) => {
                                        console.error('Erreur lors de la récupération des posts:', error);
                                    });


                                    let allPosts = [...this.state.posts, ...posts];
                                    console.log("allPosts");
                                    console.log(allPosts);
                                    this.setState({ posts: allPosts });
                                }}
                                style={{ width: "100%", maxWidth: "800px", marginLeft: "auto", marginRight: "auto", backgroundColor: "#3f51b5", color: "#fff"
                                    , center: "center", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "5px", padding: "10px 20px" }}
                            >
                                {dyn_string('g_label_load_more')}
                            </Button>
                        </div>
                    }
                </div>
            );
        }
    }

    renderCategory = (tile, key) => {
        return <PostItem tile={tile} key={key} dataPage={this.props.dataPage} fetchSocialPosts={this.fetchSocialPosts} handleNewPost={this.handleNewPost} handleLike={this.handleLike} handleOpen={this.handleOpen} handleClose={this.handleClose} handleShowLikes={this.handleShowLikes} onUpdateState={this.handleUpdateFromChild}/>
    }

    fetchSocialPosts = async (lastPostIdp) => {
        const state = store.getState();

        let token = '';
        if (typeof state.profil.mobinaute.accounts !== 'undefined' && typeof state.profil.mobinaute.accounts.shapper_token !== 'undefined') {
            token = state.profil.mobinaute.accounts.shapper_token.access_token;
        } else if (typeof state.application.deviceToken !== 'undefined') {
            token = state.application.deviceToken.access_token;
        }


        let searchParams = {
            'contentId': this.props.dataPage.id,
        };

        if (lastPostIdp) {
            searchParams.lastPostId = lastPostIdp;
        }

        const response = await fetch(baseApiUrl + '/getSocialPosts', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `Bearer ${token}`,
            },

            body: new URLSearchParams(searchParams)
        });

        const data = await response.json();

        console.log("getSocialPosts");

        console.log(data);

        console.log(data.success);

        console.log(data.result);

        if (!data.success) {
            throw new Error('Erreur lors de la récupération des posts');
        }




        if(!data.result || data.result.length === 0) {
            console.log("Aucun post trouvé");

            this.setState({ posts: data.result });

            return [];
        }
        else {
            let lastId = data.result[data.result.length - 1].id;

            this.setState({ lastPostId: lastId });

            this.setState({ posts: data.result });

            return data.result;
        }

    };

    handleNewPost = async (post) => {
        console.log("handleNewPost");
        console.log(post);
        //send post to api
        const state = store.getState();

        let token = '';
        if (typeof state.profil.mobinaute.accounts !== 'undefined' && typeof state.profil.mobinaute.accounts.shapper_token !== 'undefined') {
            token = state.profil.mobinaute.accounts.shapper_token.access_token;
        } else if (typeof state.application.deviceToken !== 'undefined') {
            token = state.application.deviceToken.access_token;
        }

        let body = new URLSearchParams({
            'contentId': this.props.dataPage.id,
            'title': post.title,
            'content': post.message
        });

        if (post.socialPostId) {
            body.append('socialPostId', post.socialPostId);
        }

        let mediaUrlParam = "";
        post.image.map( (image) => {
            if (image.startsWith('http://static.shapper.net/726/')) {
                image = image.replace('http://static.shapper.net/726/', '');
            }
            if (image.startsWith('https://static.shapper.net/726/')) {
                image = image.replace('https://static.shapper.net/726/', '');
            }
        });
        if (post.image && post.image.length > 0) {
            post.image.forEach((image) => {
                mediaUrlParam += image + ',';
            });
        }

        body.append('mediaUrl', mediaUrlParam);

        let attachmentUrlParam = "";
        post.fileUrl.map( (file) => {
            if (file.startsWith('http://static.shapper.net/726/')) {
                file = file.replace('http://static.shapper.net/726/', '');
            }
            if (file.startsWith('https://static.shapper.net/726/')) {
                file = file.replace('https://static.shapper.net/726/', '');
            }
        });

        if (post.fileUrl && post.fileUrl.length > 0) {
            post.fileUrl.forEach((file) => {
                attachmentUrlParam += file + ',';
            });
        }
        body.append('fileUrl', attachmentUrlParam);

        if (post.keywords) {
            body.append('keywords', post.keywords);
        }

        if (post.socialFeedIds) {
            body.append('socialFeedIds', post.socialFeedIds);
        }

        const response = await fetch(baseApiUrl + '/sendSocialPost', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `Bearer ${token}`,
            },
            body: body

        });
        const data = await response.json();
        console.log("sendSocialPost");
        console.log(data);
        console.log(data.success);
        if (!data.success) {
            throw new Error('Erreur lors de l\'envoi du post');
        }
        else {
            console.log("Post envoyé avec succès");
            this.setState({
                selectedImages: [],
                selectedImageUrls: [],
                selectedVideos: [],
                selectedVideoUrls: [],
                selectedAttachments: [],
                selectedAttachmentUrls: [],
            });
        }
        return data.result || [];

    }
}

// send form new post



const mapStateToProps = (props) => ({
    styles: props.style,
    posts: props.posts || [],

});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {},
        dispatch
    );

export default compose(withTranslation(), connect(mapStateToProps, mapDispatchToProps()))(SocialFeed);